/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IImageGridViewProps } from './image-grid';

export default (props: IImageGridViewProps) => {
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_get_inspired'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <h3
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{ textAlign: 'center', borderStyle: 'none', borderWidth: '1px', borderRadius: '0px' }}
                >
                    &nbsp;{props.config.title}
                </h3>
                <div
                    data-content-type='text'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px', padding: '0px' }}
                >
                    <p style={{ textAlign: 'center' }}> {props.config.description}</p>
                </div>
                <div
                    className='block_get_inspired'
                    data-content-type='block'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px', padding: '0px' }}
                >
                    <div className='widget block block-static-block'>
                        <div data-content-type='row' data-appearance='contained' data-element='main'>
                            <div
                                data-enable-parallax={0}
                                data-parallax-speed='0.5'
                                data-background-images='{}'
                                data-background-type='image'
                                data-video-loop='true'
                                data-video-play-only-visible='true'
                                data-video-lazy-load='true'
                                data-video-fallback-src
                                data-element='inner'
                                style={{
                                    justifyContent: 'flex-start',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundPosition: 'left top',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundAttachment: 'scroll',
                                    borderStyle: 'none',
                                    borderWidth: '1px',
                                    borderRadius: '0px',
                                    margin: '0px',
                                    padding: '0px'
                                }}
                            >
                                <div
                                    className='GetInspired'
                                    data-content-type='text'
                                    data-appearance='default'
                                    data-element='main'
                                    style={{
                                        borderStyle: 'none',
                                        borderWidth: '1px',
                                        borderRadius: '0px',
                                        margin: '0px',
                                        padding: '0px'
                                    }}
                                >
                                    <h1 style={{ textAlign: 'center' }} />
                                    <p style={{ textAlign: 'center' }} />
                                    {props.config.images &&
                                        props.config.images.map((image, index) => {
                                            return (
                                                <div key={index} className='GetInspired-Wrapper'>
                                                    <div className='GetInspired-ImageWrapper'>
                                                        <a href={image.url?.destinationUrl}>
                                                            <img
                                                                className='GetInspired-Image'
                                                                src={image.imageUrl?.src}
                                                                alt={image.imageUrl?.altText}
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    <p />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
